import React from 'react';
import { Link } from 'react-router-dom';
import * as PermissionsConstants from "../../const/constants.js";
import data from "../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import apiRoutes from "../../assets/apiRoutes.json";
import axios from "axios";
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
export const fetchTransactionData = (searchQuery, accessToken,
  fileType,
  delDateFrom,
  delDateTo,
  historyType,
  transactionStatus,
  ourValue,
  theirValue,
  request997,
  tranSet,
  tradingPartner,
  maxRows,
  direction) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      fileType: function () {
        return fileType;
      },
      delDateFrom: function () {
        return delDateFrom;
      },
      delDateTo: function () {
        return delDateTo;
      },
      historyType: function () {
        return historyType;
      },
      transactionStatus: function () {
        return transactionStatus;
      },
      ourValue: function () {
        return ourValue;
      },
      theirValue: function () {
        return theirValue;
      },
      request997: function () {
        return request997;
      },
      tranSet: function () {
        return tranSet;
      },
      tradingPartner: function () {
        return tradingPartner;
      },
      maxRows: function () {
        return maxRows;
      },
      direction: function () {
        return direction;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.XM.SearchTransaction}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
}

export const createTradingPartnersStore = (accessToken) => {
  // Create a new instance of Axios
  const axiosInstance = axios.create({
    baseURL: window._env_.REACT_APP_APIS, // Set your API base URL
  });

  
  return new CustomStore({
    key: 'RServiceprovid',
    load: async (loadOptions) => {
      const params = {
        skip: loadOptions.skip || 0,
        take: loadOptions.take || 10,
        searchValue: loadOptions.searchValue || '',
      };

      try {
        const response = await axiosInstance.get(data.XM.GetTradingPartners, {
          params: params,
        });

        return {
          data: response.data.data,
          totalCount: response.data.totalCount,
        };
      } catch (error) {
        console.error('Error fetching trading partners:', error);
        throw error;
      }
    },
    byKey: async (key) => {
      try {
        const response = await axiosInstance.get(`${data.XM.GetTradingPartnerById}/${key}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching trading partner by key:', error);
        throw error;
      }
    },
  });
};